// extracted by mini-css-extract-plugin
module.exports = {"ChartContainer":"ChartContainer--BCGb8"};